import React, { useEffect, useRef } from "react";
import {
  FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown, FaTimes, FaVideoSlash,
} from "react-icons/fa";
import { FaArrowLeft, FaMapMarkerAlt } from 'react-icons/fa';
import profileimg from "../../assets/profile.png";
import gallery from "../../assets/images/icons/gallery.svg";
import video from "../../assets/images/icons/video.svg";
import taguser from "../../assets/images/icons/tag-user.svg";
import send from "../../assets/images/icons/send.svg";
import search from "../../assets/images/icons/Search-2.png";
import location from "../../assets/images/icons/location-2.png";
import global from "../../assets/images/icons/global.svg";
import pipaanlogo from "../../assets/pipaanlogo.png";
import { useState } from "react";
import closecircle from "../../assets/images/icons/close-circle.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import profileData from "./profiledata";
import { useNavigate } from "react-router-dom";
import Loacationtick from "../../assets/images/icons/location-tick.svg";
import goliveicon from "../../assets/images/icons/golive-cam.svg";
import axios from "axios";
import userimg from "../../assets/user.png";
import imageCompression from "browser-image-compression";
import { v4 as uuidv4 } from "uuid";


const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function CreatepostforSeller({ posts, sellerId }) {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showTagInput, setShowTagInput] = useState(false);
  const [tags, setTags] = useState([]);
  const [hashtagSuggestions, setHashtagSuggestions] = useState([]);

  const [showLocationPage, setShowLocationPage] = useState(false);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);  // Toggle user list dropdown
  const [filteredUsers, setFilteredUsers] = useState([]);  // Store filtered users
  const [cursorPosition, setCursorPosition] = useState(0);  // Track cursor for dropdown
  // const [posts, setPosts] = useState([]);  // ✅ Store fetched posts
  const [previewUrl, setPreviewUrl] = useState(null);
  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate(); // Navigation hook
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false); // ✅ Handle loading state
  const [content, setContent] = useState(""); // ✅ Store post content
  const [mediaUrl, setMediaUrl] = useState(""); // ✅ Store media URL (if any)
  const [error, setError] = useState(null);
  const [taggedUserIds, setTaggedUserIds] = useState([]);  // Store tagged user IDs

  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [profiles, setProfiles] = useState([
    { id: 1, name: "John Doe", avatar: "https://via.placeholder.com/50", link: "/profile/1" },
    { id: 2, name: "Jane Smith", avatar: "https://via.placeholder.com/50", link: "/profile/2" },
    { id: 3, name: "Tech Group", avatar: "https://via.placeholder.com/50", link: "/group/tech" }
  ]);
  const [media, setMedia] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState('');
  const [locationInput, setLocationInput] = useState(""); // State for location input
  const [locationSuggestions, setLocationSuggestions] = useState([]); // State for location suggestions
  const [loadingLocations, setLoadingLocations] = useState(false); // Loading state for locations
  const [selectedLocation, setSelectedLocation] = useState(""); // State for selected location
  const [latitude, setLatitude] = useState(""); // State for latitude
  const [longitude, setLongitude] = useState(""); // State for longitude
  const [followersTotal, setFollowersTotal] = useState(0);    // ✅ Total followers count
  const contentEditableRef = useRef(null);

  const [visibility, setVisibility] = useState("Public"); // State to track the selected visibility option
  const [postContent, setPostContent] = useState("");
  const [productUrl, setProductUrl] = useState("");
  const [sellerProfile, setSellerProfile] = useState(null);
  useEffect(() => {
    const fetchSellerProfile = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/seller/get-seller-profile`,
          {}, // no body
          {
            headers: {
              token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
              "Content-Type": "application/json",
            },
          }
        );
        if (res.data.success) {
          setSellerProfile(res.data.result);
        }
      } catch (error) {
        console.error("Error fetching seller profile:", error);
      }
    };

    fetchSellerProfile();
  }, []);

  // State to store the profile picture URL
  const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });

  // Update profilePictureUrl when sessionStorage changes
  useEffect(() => {
    const handleProfilePictureUpdate = () => {
      const updatedProfilePictureUrl = sessionStorage.getItem("profilePictureUrl");
      if (updatedProfilePictureUrl) {
        setProfilePictureUrl(updatedProfilePictureUrl);
      }
    };

    // Add a custom event listener for profile picture updates
    window.addEventListener("profilePictureUpdated", handleProfilePictureUpdate);

    // Reinitialize profilePictureUrl on component mount
    handleProfilePictureUpdate();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("profilePictureUpdated", handleProfilePictureUpdate);
    };
  }, []);

  const extractHashtags = (text) => {
    const regex = /#(\\w+)/g;
    let match;
    const hashtags = [];

    while ((match = regex.exec(text))) {
      hashtags.push(`#${match[1]}`);
    }

    return [...new Set(hashtags)];
  };

  const handleVisibilityChange = (option) => {
    setVisibility(option); // Update the visibility state with the selected option
    setIsOpen(false); // Close the dropdown
  };

  const handleInputChange = async (e) => {
    // const value = e.target.innerText;
    let value = e.target.innerText;
    if (value.length > 2000) {
      value = value.slice(0, 2000);
      e.target.innerText = value;
      // Move cursor to end
      const range = document.createRange();
      range.selectNodeContents(e.target);
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    setContent(value);

    const lastWord = value.slice(value.lastIndexOf(" ") + 1);

    if (lastWord.startsWith("@")) {
      setShowDropdown(true);

      if (!followers?.length) {
        fetchFollowersList(); // Fetch followers if not already fetched
      }

      const query = lastWord.slice(1).toLowerCase();
      const filtered = followers.filter((user) =>
        user.first_name.toLowerCase().includes(query) ||
        user.last_name.toLowerCase().includes(query) ||
        user.username.toLowerCase().includes(query)
      );
      setFilteredUsers(filtered); // Update filtered users
    } else {
      setShowDropdown(false);
    }
    // ✅ Handle #hashtags
    if (lastWord.startsWith("#")) {
      fetchHashtagSuggestions(lastWord.slice(1)); // Fetch suggestions without the #
    } else {
      setHashtagSuggestions([]);
    }

    setTags(extractHashtags(value));
  };

  const fetchHashtagSuggestions = async (query) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/hash/get-hashs`,
        {
          filters: { search: query },
          page: 1,
          limit: 10,
        },
        {
          headers: {
            "token": sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.success) {
        const hashtags = response.data.result.hashs.map((hash) => ({
          id: hash.id,
          name: hash.hash_tag, // Use the correct property
        }));
        setHashtagSuggestions(hashtags); // this will be your dropdown
      }
    } catch (error) {
      console.error("Failed to fetch hashtags:", error);
      setHashtagSuggestions([]); // Clear suggestions on error

    }
  };

  const handleHashtagClick = (tagName) => {
    const editableDiv = contentEditableRef.current;
    const text = editableDiv.innerText;
    const words = text.split(/\s+/);
    const lastWord = words.pop();

    if (lastWord.startsWith("#")) {
      words.push(tagName); // Replace last word with tag
      const newText = words.join(" ") + " ";
      editableDiv.innerText = newText;

      // Set cursor at end
      const range = document.createRange();
      range.selectNodeContents(editableDiv);
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      setContent(newText);
      setTags(extractHashtags(newText));
      setHashtagSuggestions([]);
    }
  };


  const handleTagUser = (user) => {
    const tag = `@${user.first_name}`;
    const editableDiv = contentEditableRef.current;

    if (!editableDiv) return;

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    const textBefore = editableDiv.innerText.substring(0, range.startOffset);
    const lastWordIndex = textBefore.lastIndexOf("@");

    if (lastWordIndex !== -1) {
      // Remove partial mention
      const newTextBefore = textBefore.substring(0, lastWordIndex) + tag + " ";

      const textAfter = editableDiv.innerText.substring(range.endOffset);
      const newContent = newTextBefore + textAfter;

      editableDiv.innerText = newContent;

      // Move caret to the end of the inserted tag
      const newRange = document.createRange();
      newRange.selectNodeContents(editableDiv);
      newRange.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(newRange);

      // Update state
      setContent(newContent);
      setTaggedUserIds((prev) => [...new Set([...prev, user.id])]);
      setShowDropdown(false);
    }
  };
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleTagInput = async (e) => {
    const value = e.target.value.trim();

    // If Enter is pressed → add tag
    if (e.key === 'Enter' && value !== '') {
      setTags([...tags, value]);
      e.target.value = '';
      setShowSuggestions(false);
      return;
    }

    // If user types @ → fetch and filter
    if (value.startsWith('@')) {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      try {
        const res = await fetch(`${API_BASE_URL}/user/get-all-users`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            filters: { isTags: true },
            page: 1,
            limit: 10
          })
        });

        const data = await res.json();

        if (res.ok && data.success && data.result?.users) {
          const searchTerm = value.slice(1).toLowerCase();

          const filtered = data.result.users.filter(user =>
            `${user.first_name || ''} ${user.last_name || ''}`
              .toLowerCase()
              .includes(searchTerm)
          );

          setUserSuggestions(filtered);
          setShowSuggestions(true);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
      }
    } else {
      setShowSuggestions(false);
    }
  };


  const handleContentChange = (e) => {
    const value = e.target.value;
    setContent(value);

    const position = e.target.selectionStart;
    setCursorPosition(position);

    const lastWord = value.slice(value.lastIndexOf(" ") + 1);

    if (lastWord.startsWith("@")) {
      setShowDropdown(true);

      if (!followers?.length) {
        fetchFollowers(); // Fetch followers if not already fetched
      }

      const query = lastWord.slice(1).toLowerCase();
      const filtered = followers.filter((user) =>
        user.first_name.toLowerCase().includes(query)
      );
      setFilteredUsers(filtered);
    } else {
      setShowDropdown(false);
    }
  };

  // const handleMediaChange = async (event) => {
  //   setError(null); // Clear previous errors

  //   const files = Array.from(event.target.files);
  //   const processed = [];
  //   const videoCount = uploadedMedia.filter((m) => m.type === "video").length;

  //   for (const file of files) {
  //     const isImage = file.type.startsWith("image/");
  //     const isVideo = file.type.startsWith("video/");

  //     // Supported types
  //     const allowedImageTypes = ["image/jpeg", "image/png", "image/gif"];
  //     const allowedVideoTypes = ["video/mp4", "video/mov", "video/quicktime"];

  //     if (isImage && !allowedImageTypes.includes(file.type)) {
  //       setError("Only JPG, PNG, and GIF images are allowed.");
  //       continue;
  //     }
  //     if (isVideo && !allowedVideoTypes.includes(file.type)) {
  //       setError("Only MP4 and MOV videos are allowed.");
  //       continue;
  //     }
  //     if (!isImage && !isVideo) {
  //       setError("Unsupported file type. Only JPG, PNG, GIF images and MP4, MOV videos are allowed.");
  //       continue;
  //     }
  //     if (isImage) {
  //       if (file.size > 5 * 1024 * 1024) { // 5MB
  //         setError(`Image "${file.name}" is larger than 5MB. Please choose a smaller image.`);
  //         continue;
  //       }

  //       const processedImage = await preprocessImage(file);
  //       processed.push({
  //         id: uuidv4(),
  //         file: processedImage,
  //         original: file,
  //         url: URL.createObjectURL(processedImage),
  //         type: "image",
  //         status: "Ready",
  //         progress: 0
  //       });
  //     }

  //     if (isVideo) {
  //       if (!(file.type === "video/mp4" || file.type === "video/quicktime")) {
  //         setError("Only MP4 and MOV videos are allowed.");
  //         continue;
  //       }


  //       if (videoCount + processed.filter(f => f.type === 'video').length >= 3) {
  //         setError("You can only upload up to 3 videos.");
  //         continue;
  //       }

  //       try {
  //         const videoFile = await preprocessVideo(file);
  //         const { thumbnail } = await extractVideoThumbnail(videoFile);

  //         processed.push({
  //           id: uuidv4(),
  //           file: videoFile,
  //           thumbnail: URL.createObjectURL(thumbnail),
  //           url: URL.createObjectURL(videoFile),
  //           type: "video",
  //           status: "Ready",
  //           progress: 0
  //         });
  //       } catch (err) {
  //         console.error("Video processing failed:", err);
  //         setError("Each video must be less than 1 minute.");
  //       }
  //     }
  //   }

  //   setUploadedMedia(prev => [...prev, ...processed]);
  // };

  const handleMediaChange = async (event) => {
    setError(null);

    const files = Array.from(event.target.files);
    const processed = [];

    let imageCount = uploadedMedia.filter((m) => m.type === "image").length;
    let videoCount = uploadedMedia.filter((m) => m.type === "video").length;

    for (const file of files) {
      const isImage = file.type.startsWith("image/");
      const isVideo = file.type.startsWith("video/");

      // IMAGE VALIDATION
      if (isImage) {
        if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
          setError("❌ Only JPG, PNG, and WEBP images are allowed.");
          continue;
        }
        if (file.size > 5 * 1024 * 1024) {
          setError(`❌ Image "${file.name}" exceeds 5MB.`);
          continue;
        }
        if (imageCount >= 10) {
          setError("❌ You can only upload up to 10 images.");
          continue;
        }

        imageCount++;
        const processedImage = await preprocessImage(file);
        processed.push({
          id: uuidv4(),
          file: processedImage,
          url: URL.createObjectURL(processedImage),
          type: "image",
          status: "Ready",
          progress: 0,
        });
      }

      // VIDEO VALIDATION
      if (isVideo) {
        if (!["video/mp4", "video/quicktime"].includes(file.type)) {
          setError("❌ Only MP4 and MOV videos are allowed.");
          continue;
        }
        if (file.size > 20 * 1024 * 1024) {
          setError(`❌ Video "${file.name}" exceeds 20MB.`);
          continue;
        }
        if (videoCount >= 1) {
          setError("❌ Only 1 video is allowed per post.");
          continue;
        }

        videoCount++;
        try {
          const videoFile = await preprocessVideo(file);
          const { thumbnail } = await extractVideoThumbnail(videoFile);

          processed.push({
            id: uuidv4(),
            file: videoFile,
            thumbnail: URL.createObjectURL(thumbnail),
            url: URL.createObjectURL(videoFile),
            type: "video",
            status: "Ready",
            progress: 0,
          });
        } catch (err) {
          setError("❌ Video processing failed or exceeds duration.");
        }
      }
    }

    setUploadedMedia((prev) => [...prev, ...processed]);
  };


  const toggleTagInput = () => {
    setShowTagInput(!showTagInput); // Toggle visibility
  };
  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve token
      console.log("Retrieved Token in home page:", token); // ✅ Log token to verify
      if (!token) {
        console.log("Token not found, waiting...");
        setError("Authentication token not found!");
        return;
      }
      try {
        const response = await fetch(`${API_BASE_URL}/user/profile`, {
          method: "GET",
          headers: {
            "token": `${token}`, // ✅ Ensure proper format
            "Content-Type": "application/json"
          }
        });
        console.log("API Response Status:", response.status); // ✅ Log status
        if (!response.ok) {
          const errorData = await response.json();
          console.error("❌ API Error Data:", errorData);
          setError(errorData.message || "Failed to fetch user profile");
          return;
        }
        const data = await response.json();
        console.log("✅ API Success Response from profile page:", data); // ✅ Log full response
        setUserData(data.result);
      } catch (err) {
        console.error("❌ Fetch API Error:", err);
        setError("An error occurred while fetching the profile");
      }
    };

    fetchUserProfile();
  }, []); // ✅ Keep useEffect dependency empty

  useEffect(() => {
    const now = new Date();
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const formatted = now.toLocaleString('en-GB', options).replace(',', '');
    setCurrentDateTime(formatted);
  }, []);

  useEffect(() => {
    if (searchQuery.length >= 3) {
      const filteredResults = profiles.filter(profile =>
        profile.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery, profiles]);

  // const token =   sessionStorage.setItem("accessToken", accessToken);
  // console.log("Stored Token in homepage:", sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"));
  useEffect(() => {
    // console.log("Checking stored token:", localStorage.getItem("accessToken"));
  }, []);
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user") || localStorage.getItem("user");
    const storedToken = sessionStorage.getItem("accessToken:::::");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedToken) {
      setToken(storedToken);
    }

    console.log("Retrieved User:", storedUser);
    console.log("Retrieved Token:", storedToken);
  }, []);
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    // Retrieve user from login
    const storedUser = sessionStorage.getItem("user") || localStorage.getItem("user");
    // Retrieve userDoc from password reset
    const storedUserDoc = sessionStorage.getItem("userDoc");

    // ✅ If user exists from login, use it; otherwise, use userDoc from password reset
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    } else if (storedUserDoc) {
      setUserData(JSON.parse(storedUserDoc));
    }
  }, []);

  const retryUpload = async (index) => {
    const updated = [...uploadedMedia];
    updated[index].status = "Retrying...";
    setUploadedMedia(updated);
    await uploadFiles();
  };

  // Resize & Compress image, convert to WebP
  const preprocessImage = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1080,
      useWebWorker: true,
    };

    const compressed = await imageCompression(file, options);
    const blob = await imageCompression.getDataUrlFromFile(compressed);
    const webpBlob = await (await fetch(blob)).blob();

    // Keep the original file extension & type (JPEG/PNG)
    return new File([compressed], file.name, {
      type: file.type,
    });
  };

  const preprocessVideo = async (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.src = URL.createObjectURL(file);
      video.onloadedmetadata = () => {
        if (video.duration > 60) {
          reject("Video exceeds 1-minute limit");
        } else {
          resolve(file); // For now, we keep original. (Optional: add FFmpeg transcoding later.)
        }
      };
      video.onerror = () => {
        reject("Invalid video file");
      };
    });
  };

  // Extract thumbnail from video using <canvas>
  const extractVideoThumbnail = (videoFile) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");

      video.preload = "metadata";
      video.src = URL.createObjectURL(videoFile);
      video.muted = true;
      video.playsInline = true;
      video.onloadeddata = () => {
        canvas.width = 320;
        canvas.height = 180;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          const thumb = new File([blob], `thumb-${videoFile.name}.jpg`, {
            type: "image/jpeg"
          });
          resolve({ file: videoFile, thumbnail: thumb });
        }, "image/jpeg");
      };
    });
  };


  // Upload files function with pre-signed URL generation and S3 upload
  const uploadFiles = async () => {
    if (uploadedMedia.length === 0) return alert("Please select files");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        {
          headers: {
            'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
          }
        }
      );

      if (!response.data.success) {
        if (
          response.data.message &&
          response.data.message.includes('"body.files[0].fileType" must be one of')
        ) {
          setError("Only JPG, PNG, GIF images and MP4, MOV videos are allowed.");
        } else {
          setError(response.data.message || 'Failed to generate pre-signed URLs');
        }
        throw new Error(response.data.message || 'Failed to generate pre-signed URLs');
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          const mediaItem = uploadedMedia[index];
          const config = {
            headers: {
              'Content-Type': mediaItem.file.type
            },
            onUploadProgress: (e) => {
              const percent = Math.round((e.loaded * 100) / e.total);
              setUploadedMedia((prev) =>
                prev.map((m, i) =>
                  i === index ? { ...m, progress: percent, status: "Uploading" } : m
                )
              );
            }
          };

          try {
            await axios.put(item.presignedUrl, mediaItem.file, config);

            setUploadedMedia((prev) =>
              prev.map((m, i) =>
                i === index ? { ...m, status: "Completed", progress: 100 } : m
              )
            );

          } catch (error) {
            setUploadedMedia((prev) =>
              prev.map((m, i) =>
                i === index ? { ...m, status: "Failed", error: true } : m
              )
            );
            console.error("Upload failed:", mediaItem.file.name);
          }
        })
      );


      return preSignedUrls.map(item => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl // Extract fileUrl from API response
      }));

    } catch (error) {
      console.error('Upload error:', error);
      setError('Failed to upload files. Please try again.');
      throw new Error('Failed to upload files');
    }
  };

  // Clean up preview URLs when component unmounts
  useEffect(() => {
    return () => {
      uploadedMedia.forEach(media => {
        URL.revokeObjectURL(media.url);
      });
    };
  }, [uploadedMedia]);

  // ✅ Get User ID from sessionStorage
  const users = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  const userId = users ? users.id : null;

  // Handle post submission
  const handlePost = async () => {
    if (content.length > 200) {
      setError("Content cannot exceed 2000 characters.");
      return;
    }
    if (!userId) {
      setError("User ID not found. Please log in again.");
      return;
    }
    if (!content.trim() && uploadedMedia.length === 0) {
      setError("Content is required. Please add some text or media.");
      return;
    }

    setLoading(true);
    setError(null);
    console.log("Selected Location Before API Call:", selectedLocation); // Log the selected location

    try {
      let mediaPayload = [];
      if (uploadedMedia.length > 0) {
        mediaPayload = await uploadFiles(); // Get uploaded media URLs
      }


      const response = await axios.post(
        `${API_BASE_URL}/post/add-post`,
        {
          media_url: mediaPayload,
          content,
          tagged_user_ids: taggedUserIds,
          location: selectedLocation, // Include selected location
          latitude: latitude.toString(), // Include latitude
          longitude: longitude.toString(), // Include longitude
          hash_tags: tags, // Include hashtags
          // ✅ Seller-specific fields
          // seller_id: String(sellerId),     // convert sellerId number → string
          is_seller_post: true,
          // product_url: "https://yourshop.com/product/123", // <-- update dynamically if needed
          product_url: productUrl || "",   // make sure it's a string

        },
        {
          headers: {
            'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
          }
        }
      );

      if (!response.data.success) {
        // Check for specific error message from the API
        if (response.data.message === '"body.content" is not allowed to be empty') {
          setError("Content is required. Please add some text to your post.");
        } else {
          setError(response.data.message || "Failed to add post. Please try again.");
        }
        return;
      }

      setIsPopupOpen(false);
      setContent('');
      setUploadedMedia([]);
      setTaggedUserIds([]);
      setSelectedLocation(""); // Clear selected location
      setLatitude(""); // Clear latitude
      setLongitude(""); // Clear longitude
      setTags([]);

      window.location.reload();

      // Refresh posts if needed
      // if (fetchPosts) {
      //   fetchPosts();
      // }
    } catch (error) {
      // Handle errors from the API
      if (error.response && error.response.data && error.response.data.message) {
        if (error.response.data.message === '"body.content" is not allowed to be empty') {
          setError("Content is required. Please add some text to your post.");
        } else {
          setError(error.response.data.message || "Failed to add post. Please try again.");
        }
      } else {
        console.error('Failed to add post:', error);
        setError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchFollowers = async () => {
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    const requestBody = {
      filters: {},
      page: 1,
      limit: 10
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/user/get-all-users`,
        requestBody,
        {
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        setFollowers(response.data.result.users);  // ✅ Store users
      } else {
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      console.error("❌ Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchPosts();
  // }, []);


  const fetchFollowersList = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    try {
      const response = await fetch(`${API_BASE_URL}/friend/get-friends`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          filters: { allFollowers: true },
          page: 1,
          limit: 10,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();

      const formattedFollowers = data.result.friends.map((friend) => ({
        id: friend.user_id_1, // Use user_id_1 instead of id
        user1id: friend.User1.id, // Extract user1id
        first_name: friend.User1.first_name,
        last_name: friend.User1.last_name,
        username: friend.User1.username,
        profile_picture_url: friend.User1.profile_picture_url || userimg, // Use default image if null
      }));
      setFollowers(formattedFollowers); // Update followers state
    } catch (error) {
      console.error("Error fetching followers:", error);
    }
  };
  // ✅ Separate function for toggling state
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state

  const openPopup = () => {
    setIsPopupOpen(true);
  };
  const closePopup = () => {
    setIsPopupOpen(false);
  };
  // Function to fetch location suggestions
  const fetchLocations = async (input) => {

    if (!input.trim()) {
      setLocationSuggestions([]); // Clear suggestions if input is empty
      return;
    }

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      console.error("Token not found in sessionStorage.");
      return;
    }
    setLoadingLocations(true); // Set loading state
    try {
      const response = await axios.get(
        `${API_BASE_URL}/user/locations?input=${encodeURIComponent(input)}`,
        {
          headers: {
            "token": token, // Pass the token in headers
          },
        }
      );

      if (response.data.success) {
        setLocationSuggestions(response.data.result); // Update suggestions
      } else {
        console.error("Failed to fetch locations:", response.data.message);
        setLocationSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocationSuggestions([]);
    } finally {
      setLoadingLocations(false); // Clear loading state
    }
  };

  // Handle input change for location field
  const handleLocationInputChange = (e) => {
    const input = e.target.value;
    setLocationInput(input); // Update input state
    fetchLocations(input); // Fetch locations dynamically
  };
  // Handle location selection
  const handleLocationSelect = (location) => {
    console.log("Selected Location:", location.description); // Log the selected location

    setSelectedLocation(location.description); // Set the selected location
    setLocationInput(location.description); // Update input field with selected location

    setShowLocationPage(false); // Close the modal
    // Store latitude and longitude
    setLatitude(location.lat);
    setLongitude(location.lng);

  };
  const [activeTab, setActiveTab] = useState("Interests");
  return (
    <div>
      {/* Create Post */}
      <div className="share-content relative">
        <div className="relative">
          {/* Profile Image Inside Textarea */}
          <img
            // src={profileimg}
            src={sellerProfile?.profile_image?.url || profileimg} // Use the updated profile picture or fallback

            alt="Profile"
            className="prf absolute left-5 top-5 w-10 h-10 rounded-full"
          />
          <textarea
            placeholder="How do you want your ad to look?"
            className="share-input-field  placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 resize-none"

            value={content}
            onChange={(e) => {
              if (e.target.value.length <= 2000) setContent(e.target.value);
            }}
            maxLength={2000}                        // onChange={handleContentChange}  // ✅ Use the new handler
            onClick={openPopup} // 🔹 Open popup when clicked
          ></textarea>

          {showDropdown && (
            <div style={{ position: "absolute", top: `${cursorPosition + 20}px`, left: "10px", zIndex: 10, background: "white", border: "1px solid #ccc", padding: "10px" }}>
              {filteredUsers?.length > 0 ? (
                filteredUsers.map((user) => (
                  <div key={user.id} onClick={() => handleTagUser(user)} style={{ padding: "5px", cursor: "pointer" }}>
                    <img
                      src={user.profile_picture_url}
                      alt={user.first_name}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        marginRight: "10px",
                      }}
                    />
                    <div>
                      <p style={{ margin: 0, fontWeight: "bold" }}>
                        {user.first_name} {user.last_name}
                      </p>
                      <p style={{ margin: 0, fontSize: "12px", color: "gray" }}>
                        @{user.username}
                      </p>
                    </div>                                 </div>
                ))
              ) : (
                <p>No users found</p>
              )}
            </div>
          )}
        </div>
        {error && <p className="text-red-500 mt-2">{error}</p>}

        <div className="flex justify-between items-center mt-2">
          {/* Left Section (Image, Video, Tag Buttons) */}
          <div className="flex">

            <input
              type="file"
              accept="image/*, video/*"
              onChange={handleMediaChange}

              hidden
              id="fileUpload"
            />
            <button onClick={() => document.getElementById("fileUpload").click()} className="flex items-center px-4 py-2 rounded-lg mr-2">
              <img src={gallery} alt="Gallery" className="pr-2" /> Image
            </button>
            <button className="flex items-center px-4 py-2 rounded-lg" >
              <img src={video} alt="Video" className="pr-2" /> Video
            </button>


          </div>

          {/* Right Section (Dropdown & Post Button) */}
          <div className="flex items-center">
            {/* Public Dropdown */}
            <div>
              <button
                onClick={toggleDropdown}
                className="share-public flex items-center px-4 py-2"
              >
                <img src={global} alt="Globe" className="pr-2" />
                {visibility} {/* Display the selected visibility option */}
                <FaChevronDown className="ml-2 text-xs text-gray-400" />
              </button>

              {/* ✅ Show dropdown only if isOpen is true */}
              {isOpen && (
                <div className="absolute  bg-white shadow-md rounded-md w-40 p-2">
                  <button className="block w-full text-left px-3 py-2 hover:bg-gray-100" onClick={() => handleVisibilityChange("Public")}
                  >Public</button>
                  <button className="block w-full text-left px-3 py-2 hover:bg-gray-100" onClick={() => handleVisibilityChange("Private")}
                  >Private </button>
                  <button className="block w-full text-left px-3 py-2 hover:bg-gray-100" onClick={() => handleVisibilityChange("Friends only")}
                  > Friends only</button>
                </div>
              )}
            </div>

            {/* Post Button */}
            <button onClick={handlePost} className="post-cta flex md:px-4 md:py-2 rounded-full mx-2" disabled={loading} // ✅ Disable button when loading
            >
              {loading ? "Posting..." : (
                <>
                  <img src={send} alt="Send" className="md:pr-2" /> <span>Post</span>

                </>

              )}

            </button>

            <button className="bg-red-600 text-white text-sm px-4 py-2 rounded-full flex items-center gap-1 hover:bg-red-700 transition">
              <FaVideoSlash />
              Go Live
            </button>
            <button
              className="flex items-center space-x-2 bg-green-900 text-white px-4 py-2 rounded-full text-sm font-medium intrest-popup-cta"
            >    <FaVideoSlash />
              Create New Ad            </button>
          </div>
        </div>
      </div>
      {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
      {isPopupOpen && (
        <div className="popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
          <div className="border-popup bg-white rounded-lg  relative">
            <div className="flex justify-between">
              <div className="logo-popup flex items-center justify-center space-x-2 ">
                <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
              </div>
              {/* Close Button */}
              <button className="close-pop-x relative  text-gray-500" onClick={() => setIsPopupOpen(false)}
              >                                <img src={closecircle} alt="Pipaan Logo" className="w-10 h-10" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="share-content relative w-full">
              <div className="share-content-title p-4">
                <div className="flex pb-5">
                  {/* Profile Image Inside Textarea */}
                  <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                    <img
                      // src={user.profile_picture_url}
                      src={sellerProfile?.profile_image?.url || profileimg} // Use the updated profile picture or fallback

                      alt="Profile" className="w-full h-full object-cover" />
                  </div>
                  <div className="feed-title pl-4 flex flex-col justify-evenly">
                    <p className="font-semibold">
                      <p className="font-semibold">
                        {sellerProfile?.name || "Loading..."}
                      </p>
                    </p>
                    <div className="flex items-center gap-2 text-sm text-[#747474CC]">
                      <p>{currentDateTime || "Loading..."}</p>
                      {selectedLocation && (
                        <span className="flex items-center text-gray-500 ml-2">
                          <FaMapMarkerAlt className="inline-block mr-1 text-gray-400" />
                          {selectedLocation}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* Content-Editable Div for Inline Content and Tags */}
                {/* Content-Editable Div for Inline Content and Tags */}
                <div className="relative">
                  {/* <div
                    contentEditable
                    placeholder="Share something..."
                    onInput={handleInputChange} // Trigger input change to filter users
                    className="share-input-field focus:outline-none focus:ring-0 resize-none p-3 rounded-lg min-h-[200px]"
                    suppressContentEditableWarning={true}
                >
                    {content}
                </div> */}
                  <div
                    ref={contentEditableRef}

                    contentEditable
                    data-placeholder="How do you want your ad to look?"
                    onInput={handleInputChange}
                    className="share-input-field focus:outline-none focus:ring-0 resize-none p-3 rounded-lg min-h-[200px] text-left"
                    suppressContentEditableWarning={true}
                  />

                  {/* {content} */}

                  {/* Dropdown for tagging users */}
                  {showDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%", // Adjust dropdown position
                        left: "0",
                        zIndex: 10,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredUsers?.length > 0 ? (
                        filteredUsers.map((user) => (
                          <div
                            key={user.id}
                            onClick={() => handleTagUser(user)} // Handle user selection
                            style={{
                              padding: "5px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={user.profile_picture_url}
                              alt={user.first_name}
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                marginRight: "10px",
                              }}
                            />
                            <div>
                              <p style={{ margin: 0, fontWeight: "bold" }}>
                                {user.first_name} {user.last_name}
                              </p>
                              <p style={{ margin: 0, fontSize: "12px", color: "gray" }}>
                                @{user.username}
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No users found</p>
                      )}
                    </div>
                  )}
                  {hashtagSuggestions.length > 0 && (
                    <div className="bg-white border p-2 rounded shadow max-h-40 overflow-auto mt-2">
                      {hashtagSuggestions.map((tag) => (
                        <div
                          key={tag.id}
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1"
                          onClick={() => handleHashtagClick(tag.name)}
                        >
                          {tag.name}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Display tags outside editable div */}
                  <div className="mt-3 flex flex-wrap">
                    {tags.map((tag, index) => (
                      <span
                        key={index}
                        className={`px-1 py-1 ml-1 mr-2 mt-2 rounded-lg ${tag.startsWith('#')
                          ? 'bg-[#4988528a] text-[#095228]'
                          : 'bg-[#FFE484] text-[#98911F]'
                          }`}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Tag Input (Conditional Display) */}
                {showTagInput && (
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Add Tags"
                      className="outline-none bg-transparent border-b-2 border-gray-300 ml-2 focus:outline-none focus:ring-0 px-3 mx-4"
                      onKeyUp={handleTagInput}
                      autoFocus
                    />
                    {showSuggestions && userSuggestions.length > 0 && (
                      <ul className="absolute bg-white shadow-lg border rounded mt-1 z-50 w-64 max-h-48 overflow-y-auto">
                        {userSuggestions.map(user => (
                          <li
                            key={user.id}
                            className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                              const mention = `@${user.first_name} ${user.last_name}`.trim();

                              // 1️⃣ Keep your existing logic: add to tags array
                              setTags(prev => [...prev, mention]);

                              // 2️⃣ NEW: also insert into textarea's content
                              setContent(prev => (prev + " " + mention + " ").trim());

                              // 3️⃣ Hide suggestions
                              setShowSuggestions(false);
                            }}
                          >
                            <img
                              src={user.profile_picture_url}
                              alt={user.first_name}
                              className="w-6 h-6 rounded-full mr-2"
                            />
                            <span>{user.first_name} {user.last_name}</span>
                          </li>
                        ))}
                      </ul>
                    )}

                  </div>
                )}



                <div className="flex  items-center justify-end mt-2">
                  <p className={`text-sm ${content.length > 2000 ? 'text-red-500' : 'text-gray-400'}`}>
                    {content.length}/2000
                  </p>
                </div>

                {/* {error && <p className="text-red-500 text-sm mt-2">{error}</p>} */}
              </div>
              {/* Display Uploaded Media Preview */}
              <div className="mt-4 share-content-media">
                <div className="text-sm text-gray-600 mb-2">
                  Images: {uploadedMedia.filter((m) => m.type === "image").length}  &nbsp; | &nbsp;
                  Videos: {uploadedMedia.filter((m) => m.type === "video").length}
                </div>
                <div className="flex gap-2 flex-wrap">
                  {/* 📊 Uploaded Media Counts */}


                  {uploadedMedia.map((media, index) => (
                    <div key={media.id || index} className="relative">
                      {media.type === "image" ? (
                        <img src={media.url} className="rounded-lg max-w-[244px] max-h-[244px]" />
                      ) : (
                        <video src={media.url} controls className="rounded-lg max-w-[244px] max-h-[244px]" />
                      )
                      }
                      <div className="absolute bottom-2 left-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
                        {media.status} - {media.progress}%
                      </div>
                      <button
                        onClick={() => {
                          setUploadedMedia((prev) => prev.filter((_, i) => i !== index));
                          URL.revokeObjectURL(media.url);
                        }}
                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}
                </div>

                {error && <p className="text-red-500 mt-2">{error}</p>}
              </div>


              <div className="input-cta-post flex justify-between items-start mt-2">
                {/* Left Section (Image, Video, Tag Buttons) */}
                <div className="flex">

                  {/* Image Upload */}
                  <label className="flex items-center px-4 py-2 rounded-lg mr-2 cursor-pointer">
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={handleMediaChange}
                    />
                    <img src={gallery} alt="Gallery" className="pr-2" /> Image
                  </label>

                  {/* Video Upload */}
                  <label className="flex items-center px-4 py-2 rounded-lg cursor-pointer">
                    <input
                      type="file"
                      accept="video/mp4,video/quicktime"
                      className="hidden"
                      onChange={handleMediaChange}
                    />
                    <img src={video} alt="Video" className="pr-2" /> Video
                  </label>

                  {/* Display Selected Location */}


                  {/* <button
                    className="flex items-center px-4 py-2 rounded-lg"
                    onClick={() => setShowLocationPage(true)}
                  >
                    <img src={Loacationtick} alt="Tag" className="pr-2" /> Check In
                  </button> */}

                </div>

                {/* Right Section (Dropdown & Post Button) */}
                <div className="flex items-start post-ctas">
                  {/* Public Dropdown */}
                  <div className="pop-share-public">
                    <button
                      onClick={toggleDropdown}
                      className="share-public flex items-center px-4 py-2"
                    >
                      <img src={global} alt="Globe" className="pr-2" />
                      {visibility} {/* Display the selected visibility option */}
                      <FaChevronDown className="ml-2 text-xs text-gray-400" />
                    </button>

                    {/* ✅ Show dropdown only if isOpen is true */}
                    {isOpen && (
                      <div className="relative bg-white shadow-md rounded-md  p-2">
                        <button
                          className="block w-full text-left px-3 py-2 hover:bg-gray-100"
                          onClick={() => handleVisibilityChange("Public")}
                        >
                          Public
                        </button>
                        <button
                          className="block w-full text-left px-3 py-2 hover:bg-gray-100"
                          onClick={() => handleVisibilityChange("Private")}
                        >
                          Private
                        </button>
                        <button
                          className="block w-full text-left px-3 py-2 hover:bg-gray-100"
                          onClick={() => handleVisibilityChange("Friends only")}
                        >
                          Friends only
                        </button></div>
                    )}
                  </div>

                  {/* Post Button */}
                  <button onClick={handlePost} className="post-cta flex md:px-4 md:py-2 rounded-full mx-2" disabled={loading} // ✅ Disable button when loading
                  >
                    {loading ? "Posting..." : (
                      <>
                        <img src={send} alt="Send" className="md:pr-2" /> <span>Post</span>
                      </>
                    )}
                  </button>
                  {/* Location Modal */}
                  {showLocationPage && (
                    <div className="absolute inset-0 bg-[#f7f7f7] z-10 rounded-[20px]">
                      <div className="p-6 bg-none h-screen">
                        <div className="flex items-center justify-between mb-6">
                          <button
                            className="flex items-center text-xl text-[#000] bg-[#292d3275] rounded-full p-2"
                            onClick={() => setShowLocationPage(false)}
                          >
                            <FaArrowLeft className="mr-0" />
                          </button>
                          <h1 className="text-xl font-semibold">Search Location</h1>
                        </div>

                        <div className="relative mb-6">
                          <img
                            src={search}
                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                            alt="Search Icon"
                          />
                          <input
                            type="text"
                            placeholder="Where are you?"
                            value={locationInput}
                            onChange={handleLocationInputChange}
                            className="w-full border border-[#09522880] rounded-full pl-10 py-4 focus:outline-none"
                          />
                        </div>

                        {/* Show loading indicator */}
                        {loadingLocations && <p>Loading locations...</p>}

                        {/* Display location suggestions */}
                        {/* <h2 className="text-lg font-[600] m-5">Suggesteddddd</h2>
            <div className="space-y-4 m-5">
              {locationSuggestions.length > 0 ? (
                locationSuggestions.map((loc, index) => (
                  <div
                    key={index}
                    className="flex items-center border-b pb-4 cursor-pointer"
                    onClick={() => handleLocationSelect(loc)}
                  >
                    <img src={location} className="text-gray-500 mr-3" alt="Location Icon" />
                    <div>
                      <p className="font-semibold">{loc.description}</p>
                      <p className="text-sm text-gray-500">{loc.address}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-gray-500">No locations found.</p>
              )}
            </div> */}
                      </div>
                    </div>
                  )}

                  <button className="golive-cta flex md:px-4 md:py-2 rounded- mx-2" onClick={() => navigate("/golive")}  // ✅ Navigate to "Go Live" page
                    disabled={loading} // ✅ Disable button when loading
                  >

                    <>
                      <img src={goliveicon} alt="Send" className="md:pr-2" /> <span>Go Live</span>
                    </>

                  </button>
                </div>
              </div>
              {/* Search Location Component - Visible on Check In */}
              {showLocationPage && (
                <div className="absolute inset-0 bg-[#f7f7f7] z-10 rounded-[20px]">

                  <div className="p-6 bg-none h-screen">
                    <div className="flex items-center justify-between mb-6">
                      <button
                        className="flex items-center text-xl text-[#000] bg-[#292d3275] rounded-full p-2"
                        onClick={() => setShowLocationPage(false)} // Close the modal directly
                      >
                        <FaArrowLeft className="mr-0" />
                      </button>
                      <h1 className="text-xl font-semibold">Search Location</h1>
                    </div>

                    <div className="relative mb-6">

                      <img src={search} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                      <input
                        type="text"
                        placeholder="Where are you?"
                        value={locationInput}
                        onChange={handleLocationInputChange} // Handle input change

                        className="w-full border border-[#09522880] rounded-full pl-10 py-4 focus:outline-none"
                      />
                    </div>

                    {/* Show loading indicator */}
                    {loadingLocations && <p>Loading locations...</p>}

                    {/* Display location suggestions */}
                    <h2 className="text-lg font-[600] m-5">Suggested</h2>
                    <div className="space-y-4 m-5">
                      {locationSuggestions.length > 0 ? (
                        locationSuggestions.map((loc, index) => (
                          <div
                            key={index}
                            className="flex items-center border-b pb-4 cursor-pointer"
                            onClick={() => handleLocationSelect(loc)} // Call handleLocationSelect on click

                          >
                            <img src={location} className="text-gray-500 mr-3" alt="Location Icon" />
                            <div>
                              <p className="font-semibold">{loc.description}</p>
                              <p className="text-sm text-gray-500">{loc.address}</p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-500">No locations found.</p>
                      )}
                    </div>



                  </div>
                </div>
              )}


            </div>
          </div>
        </div>
      )}
    </div>
  );
}